var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('Access denied')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('You are unauthorized to access this page.')))])])}
var staticRenderFns = []

export { render, staticRenderFns }